import * as React from 'react';
export const AccessLimited = ({ limit="7\u00A0дней", className, margin, color, align, font }) => {
  return (
    <p
      className={className}
      style={{
        margin: margin,
        color: color,
        textAlign: align,
        fontSize: font,
        position: "relative",
        zIndex: "999"
      }}>
      Бесплатный доступ действителен в&nbsp;течение { limit }
    </p>
  );
};
